export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-widget-da38a3e84f5eb65dc9b2af3755124195.svg";